/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductConversionFieldDto } from '../../models/backend-advanced-product-conversion-field-dto';
import { BackendPatchedAdvancedProductConversionFieldRequestDto } from '../../models/backend-patched-advanced-product-conversion-field-request-dto';

export interface SalesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedAdvancedProductConversionFieldRequestDto;
}

export function salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded.PATH,
    'patch',
  );
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductConversionFieldDto>;
    }),
  );
}

salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded.PATH =
  '/api/sales/advanced-product-conversion-fields/{id}/';
